import { Button, DatePicker, Form, Input, InputNumber, Select, theme } from "antd";
import { filterOption, fiscalCodeField, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance, { api } from "../common/api";
import { useNavigate } from "react-router";
import axios from "axios";
import SimpleFormPage from "../common/SimpleFormPage";
import dayjs from "dayjs";

export default function () {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    api.equipmentType
      .list({ pageSize: 9999 })
      .then((data) => setTypes(data.data.map((x) => ({ label: x.name, value: x.id }))));
  }, []);

  return (
    <SimpleFormPage
      title="Nuova attrezzatura"
      path="equipment"
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item label="Categoria" name="equipmentType">
        <Select options={types} showSearch filterOption={filterOption} />
      </Form.Item>
      <Form.Item label="Matricola" rules={[requiredField]} name="serialCode">
        <Input />
      </Form.Item>
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>
      <Form.Item
        label="Data ultima ispezione (oppure data di acquisto)"
        name="firstInspectionDate"
        getValueProps={(value) => ({ value: value && dayjs(value) })}
        normalize={(value) => value && value.format("YYYY-MM-DD")}
      >
        <DatePicker format={"DD-MM-YYYY"} />
      </Form.Item>
      <Form.Item label="Note" name="notes">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
